module.exports = __webpack_public_path__ + "img/blog-50.8e88a672.jpg";